import React from "react";
import { Route, Switch } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import Users from "../pages/Users/users"
import Aplicacoes from "../pages/Applications/applications"
import Roles from "../pages/Roles/roles"
import Partners from "../pages/Partners/partners"
import Modules from "../pages/Modules/modules"
import Functions from "../pages/Functions/functions"
import DadosPessoais from "../pages/DadosPessoais/dadosPessoais";
import SegurancaLogin from "../pages/SegurancaLogin/segurancaLogin";
import UnlockUser from "../pages/UnlockUser/unlockUser";
import Feedbacks from "../pages/Feedbacks/feedbacks";
import mahaUserNotFound from "../pages/Others/mahaUserNotFound";
import Certifications from "../pages/Certifications/certifications";
import Notifications from "../pages/Notifications/notifications";
import UserPermissions from "../pages/UserPermissions/UserPermissions";
import Privacy from "../pages/Privacy/privacy";
import AccessManagement from "../pages/AccessManagement/accessManagement";
import { GuardProvider, GuardedRoute } from 'react-router-guards';
import App from "./App";
import ServiceModule from '../services/modules';

export default () => {

    const checkPathAccess = async (userID, to) => {
        const permissions = await ServiceModule.getModulesPermissionsByUser(userID);
        
        if (permissions && permissions[0]?.modules) {
            return permissions[0].modules.some(permission => permission.url === to.location.pathname);
        }
    
        return false;
    };

    const requireAuthorization = (to, from, next) => {
        const SankhyaHub = window['SankhyaHub'];
    
        if (!SankhyaHub) return;
    
        SankhyaHub.setApplicationId(2);
    
        SankhyaHub.ready(async () => {
            if (SankhyaHub.isReady()) {
                const user = SankhyaHub.getUser();
                const userID = user.id;
                const toLocationPathname = to.location.pathname;
                const currentURL = new URL(document.location.href);
    
                const isAllowedPath = await checkPathAccess(userID, to);
    
                if (toLocationPathname === "/" || !isAllowedPath) {
                    next.redirect("/dadospessoais" + currentURL.search);
                } else {
                    next();
                }
            }
        });
    };    

    return (
        <Router >
            <GuardProvider guards={[requireAuthorization]}>
                <Switch>
                    <GuardedRoute exact path="/" />
                    <Route path="/unlock-user" component={UnlockUser} />
                    <Route path="/mahaUserNotFound" component={mahaUserNotFound} />
                    <App>
                        <Route path="/dadospessoais" component={DadosPessoais} />
                        <Route path="/seguranca-login" component={SegurancaLogin} />
                        <Route path="/my-permissions" component={UserPermissions} />
                        <Route path="/privacy" component={Privacy} />
                        <Route path="/gestao-acessos" component={AccessManagement} />
                        <GuardedRoute path="/users" component={Users} />
                        <GuardedRoute path="/applications" component={Aplicacoes} />
                        <GuardedRoute path="/roles" component={Roles} />
                        <GuardedRoute path="/partners" component={Partners} />
                        <GuardedRoute path="/modules" component={Modules} />
                        <GuardedRoute path="/functions" component={Functions} />
                        <GuardedRoute path="/feedbacks" component={Feedbacks} />
                        <GuardedRoute path="/certifications" component={Certifications} />
                        <GuardedRoute path="/notifications" component={Notifications} />
                    </App>
                </Switch>
            </GuardProvider>
        </Router>
    )
}
